<template>
    <iframe
        ref="opIframeRef"
        :src="opIframeUrl"
        id="bussola-op-session-iframe"
        title="OP Session"
        class="op-session-iframe"
    />
</template>
<script setup>
import {onMounted, ref, watch} from 'vue';
import {OpSessionService} from '@/core/services/OpSessionService.js';
import {useOpSession} from '@/composables/useOpSession.js';
import {useUserInfo} from '@/composables/useUserInfo.js';
import {AuthService} from '@/core/services/AuthService.js';

const opIframeRef = ref(null);
const opSessionService = OpSessionService.getInstance();
const opIframeUrl = opSessionService.opIframeUrl;
const {startMonitoring} = useOpSession();
const {userInfoLoaded} = useUserInfo();
const authService = AuthService.getInstance();

const syncMonitoring = () => {
    if (userInfoLoaded.value && authService.isAuthenticated()) {
        startMonitoring();
    }
};

watch(
    [userInfoLoaded, () => AuthService.authState.value],
    syncMonitoring,
    {immediate: true}
);

const bindIframe = () => {
    if (opIframeRef.value) {
        opSessionService.bindOpIframe(opIframeRef.value);
        opIframeRef.value.addEventListener('load', () => opSessionService.checkSession());
    }
};

onMounted(() => {
    bindIframe();
});

</script>
<style scoped>
.op-session-iframe {
    display: none;
    height: 0;
    width: 0;
    border: 0;
    position: absolute;
}
</style>
